import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAllCategories } from '../data/api';

// Create the navigation context
const NavigationContext = createContext();

// Hook for using the navigation context
export const useNavigation = () => useContext(NavigationContext);

// Provider component
export const NavigationProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Fetch all categories on initial load
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoriesData = await getAllCategories();
        setCategories(categoriesData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching navigation data:', error);
        setLoading(false);
      }
    };
    
    fetchCategories();
  }, []);
  
  // Format navigation items for the sidebar
  const navigationItems = categories.map(category => ({
    id: category.slug,
    name: category.title,
    path: `/${category.slug}`,
    subcategories: category.subcategories?.map(sub => ({
      id: sub.slug,
      name: sub.title,
      path: `/${category.slug}/${sub.slug}`
    })) || []
  }));
  
  // Value to be provided to consumers
  const value = {
    navigationItems,
    categories,
    loading
  };
  
  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationProvider; 